/** Pure label decisions for the Reconciliation page's density pass.
 *
 *  The page's three alert bands compress into one-line chips; these helpers
 *  own the wording so the figures are pinned by test — the plan's rule that
 *  every number survives a density pass, only geometry changes.
 */

const fmt = new Intl.NumberFormat('en-IN')

/** The violet "manual match groups await reviewer approval" alert, as one
 *  short line beside the progress meter. */
export function pendingLine(n: number): string | null {
  if (n <= 0) return null
  return `${fmt.format(n)} match group(s) awaiting approval`
}

/** The orange "approved alias groups were not applied" alert, as one line —
 *  the group list and the why live behind the ⓘ beside it. */
export function withheldLine(n: number): string | null {
  if (n <= 0) return null
  return `${fmt.format(n)} approved alias group(s) not applied`
}

/** Ageing (Stage F): how long a party's oldest open entry has been open.
 *  Null until a full day has passed — "open 0 d" is noise, not information. */
export function openForDays(
  openSince: string | null | undefined,
  today: Date,
): string | null {
  if (!openSince) return null
  const days = Math.floor(
    (today.getTime() - new Date(openSince + 'T00:00:00Z').getTime())
    / 86_400_000)
  if (days <= 0) return null
  return `open ${fmt.format(days)} d`
}

/** The yellow "aliases approved since this run" alert on the worklist, as a
 *  line plus the same three-name preview the alert printed. */
export function staleAliasLine(
  names: string[],
): { label: string; preview: string } | null {
  if (names.length === 0) return null
  return {
    label: `${fmt.format(names.length)} approved alias group(s) await a re-run`,
    preview: names.slice(0, 3).join(', ') + (names.length > 3 ? '…' : ''),
  }
}
